import { Router } from "../router";
import { GlobalStyle } from "../styles/global";

export function HomePage() {
  return (
    <>
      <Router />
      <GlobalStyle />
    </>
  );
}
